import { render } from "./OUpload.vue?vue&type=template&id=76cb7353&scoped=true"
import script from "./OUpload.vue?vue&type=script&lang=js"
export * from "./OUpload.vue?vue&type=script&lang=js"

import "./OUpload.vue?vue&type=style&index=0&id=76cb7353&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cb7353"]])

export default __exports__